var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 560,
    preserveAspectRatio: "none",
    viewBox: "0 0 1440 560",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(\"#SvgjsMask1030\")",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0L1004.99 0L1440 103.6z",
    fill: "rgba(255, 255, 255, .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.99 0L1440 103.6L1440 276.54999999999995L682.75 0z",
    fill: "rgba(255, 255, 255, .075)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.75 0L1440 276.54999999999995L1440 386.35999999999996L346.05 0z",
    fill: "rgba(255, 255, 255, .05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.04999999999995 0L1440 386.35999999999996L1440 505.64L244.41999999999996 0z",
    fill: "rgba(255, 255, 255, .025)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 560L559.15 560L0 486.17z",
    fill: "rgba(0, 0, 0, .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 486.17L559.15 560L898.67 560L0 281.01z",
    fill: "rgba(0, 0, 0, .075)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 281.01L898.67 560L913.4 560L0 219.12z",
    fill: "rgba(0, 0, 0, .05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 219.12L913.4 560L930.5799999999999 560L0 70.14000000000001z",
    fill: "rgba(0, 0, 0, .025)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "SvgjsMask1030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 560,
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestOverlay);
export default __webpack_public_path__ + "static/media/TestOverlay.fa4538f5235368e053a9a65258d887d7.svg";
export { ForwardRef as ReactComponent };